import { render, staticRenderFns } from "./HeaderBg.vue?vue&type=template&id=5cf3e3b2&scoped=true&"
import script from "./HeaderBg.vue?vue&type=script&lang=js&"
export * from "./HeaderBg.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBg.vue?vue&type=style&index=0&id=5cf3e3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3e3b2",
  null
  
)

export default component.exports